import api from './api'; // Replace with the actual path to your API functions
import Vuex from 'vuex';
const store = new Vuex.Store({
    state: {
        cart: [] // الحالة الأولية للسلة على شكل مصفوفة
    },
    mutations: {
        autoAddToCart(state, cartItem) {
            const index = state.cart.findIndex(item => item.id === cartItem.id);
            if (index !== -1) {
                state.cart.splice(index, 1, cartItem);
            } else {
                state.cart.push(cartItem);
            }
        },
        addToCart(state, cartItem) {
            const index = state.cart.findIndex(item => item.id === cartItem.id);
            if (index !== -1) {
                state.cart.splice(index, 1, cartItem);
            } else {
                state.cart.push(cartItem);
            }
        },
        removeFromCart(state, cartItemId) {
            state.cart = state.cart.filter(item => item.id !== cartItemId);
        }
    },
    actions: {
        async autoAddToCart({ commit }, cartItem) {
            commit('autoAddToCart', cartItem);
        },
        async addToCart({ commit }, payload) {
            // إجراء الاتصال بالـ API
            const response = await api.addToCart({
                'quantity': payload.quantity,
                'product_id': payload.product.id
            });

            if (response && response.status) {
                // تحديث السلة في Vuex Store
                commit('addToCart', { ...payload, id: response.data.id, quantity: response.data.quantity });
            }
            return response;
        },
        async removeFromCart({ commit }, cartItemId) {
            // إجراء الاتصال بالـ API
            await api.removeFromCart({ id: cartItemId });

            // إزالة العنصر من السلة
            commit('removeFromCart', cartItemId);
        }
    },
    getters: {
        cartItems: state => {
            return state.cart;
        }
    }
});
export default store;

// const store = new Vuex.Store({
//     state: {
//         cart: {} // Initial cart state as an object with product IDs as keys and product objects as values
//     },
//     mutations: {
//         autoAddToCart(state, product) {
//             state.cart[product.id] = { ...product,};
//         },
//         addToCart(state, product) {
//             state.cart[product.id] = { ...product, };
//         },
//         removeFromCart(state, product) {
//             if (state.cart[product.id]) {
//                 delete state.cart[product.id];
//             }
//         }
//     },
//     actions: {
//         async autoAddToCart({ commit }, product) {
//             commit('autoAddToCart', product);
//         },
//         async addToCart({ commit },  payload ) {
//
//             // Make API call to add product to the cart
//             const response = await api.addToCart({
//                 'quantity': payload?.quantity,
//                 'product_id': payload?.product?.id
//             });
//
//
//             commit('addToCart',  {
//                 ...payload?.product,
//                 cart: response?.data // new cart Values
//             });
//             return response;
//         },
//         async removeFromCart({ commit }, product) {
//             console.log(product);
//             console.log(product.cart);
//             // Make API call to remove product from the cart
//             await api.removeFromCart(product.cart);
//
//             commit('removeFromCart', product);
//         }
//     },
//     getters: {
//         cartItems: state => {
//             return Object.values(state.cart);
//         }
//     }
// });
//
// export default store;
